import { StyleSheet } from 'react-native';
import { Colors } from '@qnpm/q-theme';
const { scenes: { checkBoxColors, baseColor } } = Colors;
/**
 * 标签类型Wrapper通用样式
 */
const kCommonLabelWraperStyle = {
    overflow: 'hidden',
    jusityContent: 'center',
    alignItems: 'center'
};
/**
 * 标签类型图标通用样式
 */
const kCommonLabelIconStyle = {
    position: 'absolute',
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    jusityContent: 'center',
    alignItems: 'center',
    backgroundColor: checkBoxColors.brand
};
/**
 * 基础类型通用图片icon样式
 */
const kCommonBaseImgIconStyle = {
    width: '100%',
    height: '100%'
};
const kCheckBoxBaseTypeStyle = {
    unavailable: {
        wrapper: {},
        icon: Object.assign({}, kCommonBaseImgIconStyle)
    },
    unselected: {
        wrapper: {},
        icon: Object.assign({}, kCommonBaseImgIconStyle)
    },
    selected: {
        wrapper: {},
        icon: Object.assign({}, kCommonBaseImgIconStyle)
    }
};
export const styles = {
    /** 蓝色实心 */
    brandSolid: Object.assign({}, kCheckBoxBaseTypeStyle),
    /** 蓝色空心 */
    brandEmpty: Object.assign({}, kCheckBoxBaseTypeStyle),
    /** 灰色实心 */
    graySolid: Object.assign({}, kCheckBoxBaseTypeStyle),
    /** 灰色空心 */
    grayEmpty: Object.assign({}, kCheckBoxBaseTypeStyle),
    /** 标签类型，面型，无边框 */
    side: {
        unavailable: {
            wrapper: Object.assign(Object.assign({}, kCommonLabelWraperStyle), { backgroundColor: checkBoxColors.silverBackgroud }),
            text: {
                color: baseColor.disableText
            },
            icon: Object.assign(Object.assign({}, kCommonLabelIconStyle), { opacity: 0 })
        },
        unselected: {
            wrapper: Object.assign(Object.assign({}, kCommonLabelWraperStyle), { backgroundColor: checkBoxColors.silverBackgroud }),
            text: {
                color: checkBoxColors.text
            },
            icon: Object.assign(Object.assign({}, kCommonLabelIconStyle), { opacity: 0, fontSize: 11 })
        },
        selected: {
            wrapper: Object.assign(Object.assign({}, kCommonLabelWraperStyle), { backgroundColor: checkBoxColors.brandBackground }),
            text: {
                color: checkBoxColors.brandText
            },
            icon: Object.assign(Object.assign({}, kCommonLabelIconStyle), { opacity: 1 })
        }
    },
    /** 标签类型，线型，有边框 */
    line: {
        unavailable: {
            wrapper: Object.assign(Object.assign({}, kCommonLabelWraperStyle), { backgroundColor: checkBoxColors.silverBackgroud }),
            text: {
                color: baseColor.disableText
            },
            icon: Object.assign(Object.assign({}, kCommonLabelIconStyle), { opacity: 0 })
        },
        unselected: {
            wrapper: Object.assign(Object.assign({}, kCommonLabelWraperStyle), { backgroundColor: checkBoxColors.whiteBackground }),
            text: {
                color: checkBoxColors.text
            },
            icon: Object.assign(Object.assign({}, kCommonLabelIconStyle), { opacity: 0 })
        },
        selected: {
            wrapper: Object.assign(Object.assign({}, kCommonLabelWraperStyle), { backgroundColor: checkBoxColors.whiteBackground }),
            text: {
                color: checkBoxColors.brandText
            },
            icon: Object.assign(Object.assign({}, kCommonLabelIconStyle), { opacity: 1 })
        }
    },
    border: {
        unavailable: {
            borderWidth: StyleSheet.hairlineWidth,
            borderColor: checkBoxColors.silverBorder
        },
        unselected: {
            borderWidth: StyleSheet.hairlineWidth,
            borderColor: checkBoxColors.silverBorder
        },
        selected: {
            borderWidth: StyleSheet.hairlineWidth,
            borderColor: checkBoxColors.brandText
        }
    }
};
